const iconCheckOk = `
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="12" viewBox="0 0 15 12">
      <polyline fill="none" stroke="#27E9D6" stroke-width="3" points="38 197.992 42.011 202.003 50.02 194" transform="translate(-37 -193)"/>
    </svg>
`;

export default iconCheckOk;
